if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        
        if (this.submitButton) {
          this.submitButtonText = this.submitButton.querySelector('span');
          if (document.querySelector('cart-drawer')) {
            this.submitButton.setAttribute('aria-haspopup', 'dialog');
          }
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.pendingFormData = null;
        this.isFromAddonModal = false;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // Check if this is being called from within the addon modal
        const clickedFromModal = evt.target.closest('.addon-modal[open]');
        this.isFromAddonModal = !!clickedFromModal;

        // Check if this is the main product form (not from addon modal)
        if (!this.isFromAddonModal) {
          const addonModal = this.getAddonModal();
          if (addonModal) {
            this.showAddonModal(addonModal, evt);
            return;
          }
        }

        // Proceed with add to cart (either from modal or direct)
        this.proceedWithAddToCart(evt);
      }

      getAddonModal() {
        try {
          const productInfo = this.closest('product-info');
          if (!productInfo) return null;

          const sectionId = productInfo.dataset.section;
          if (!sectionId) return null;

          const modal = document.getElementById(`AddOnModal-${sectionId}`);
          if (!modal) return null;

          const modalProducts = modal.querySelector('.addon-modal__products');
          if (!modalProducts) return null;

          const productCards = modalProducts.querySelectorAll('.grid__item');
          if (!productCards || productCards.length === 0) return null;

          const addOnSection = document.getElementById(`AddOnAccessories-${sectionId}`);
          if (addOnSection) {
            const addOnProducts = addOnSection.querySelectorAll('.grid__item');
            if (!addOnProducts || addOnProducts.length === 0) return null;
          }

          return modal;
        } catch (error) {
          console.warn('Error getting addon modal:', error);
          return null;
        }
      }

      showAddonModal(modal, evt) {
        try {
          this.pendingFormData = new FormData(this.form);
          this.pendingEvent = evt;
          this.mainProductAdded = false;

          const closeButton = modal.querySelector('[id^="ModalClose-"]');
          
          if (closeButton) {
            const newCloseButton = closeButton.cloneNode(true);
            closeButton.parentNode.replaceChild(newCloseButton, closeButton);
            
            newCloseButton.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();

              // Reset close button text back to "No Thanks" when modal closes
              const closeText = newCloseButton.querySelector('.addon-modal__close-text');
              if (closeText) {
                closeText.textContent = newCloseButton.dataset.noThanksText || 'No Thanks';
                newCloseButton.classList.remove('addon-modal__close-button--updated');
              }

              this.closeAddonModal(modal);
            });
          }

          // Add backdrop click listener
          const backdropListener = (e) => {
            if (e.target === modal) {
              // Reset close button text on backdrop click too
              const closeBtn = modal.querySelector('[id^="ModalClose-"]');
              if (closeBtn) {
                const closeText = closeBtn.querySelector('.addon-modal__close-text');
                if (closeText) {
                  closeText.textContent = closeBtn.dataset.noThanksText || 'No Thanks';
                  closeBtn.classList.remove('addon-modal__close-button--updated');
                }
              }
              this.closeAddonModal(modal);
              modal.removeEventListener('click', backdropListener);
            }
          };
          modal.addEventListener('click', backdropListener);

          if (typeof modal.show === 'function') {
            modal.show(this.submitButton);
          }

          // Add main product to cart immediately when modal opens
          this.addMainProductToCart();

        } catch (error) {
          console.error('Error showing addon modal:', error);
          this.proceedWithAddToCart(evt);
        }
      }

      addMainProductToCart() {
        if (this.mainProductAdded) return;

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = this.pendingFormData;
        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
        }
        
        config.body = formData;
        
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (!response.status) {
              this.mainProductAdded = true;
              
              // Update cart icon count without opening drawer
              if (this.cart) {
                this.updateCartCount(response);
              }

              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }
          })
          .catch((e) => {
            console.error('Error adding main product:', e);
          });
      }

      updateCartCount(response) {
        // Update cart count/icon without opening the drawer
        const cartIconBubble = document.getElementById('cart-icon-bubble');
        if (cartIconBubble && response.sections && response.sections['cart-icon-bubble']) {
          const cartIconHTML = new DOMParser().parseFromString(
            response.sections['cart-icon-bubble'],
            'text/html'
          );
          const newCartIconBubble = cartIconHTML.getElementById('cart-icon-bubble');
          if (newCartIconBubble) {
            cartIconBubble.innerHTML = newCartIconBubble.innerHTML;
          }
        }
      }

      closeAddonModal(modal) {
        // THE FIX: Remove is-empty class BEFORE opening cart drawer
        if (this.cart && this.cart.classList.contains('is-empty')) {
          this.cart.classList.remove('is-empty');
        }
        
        try {
          if (typeof modal.hide === 'function') {
            modal.hide();
          }

          // Open cart drawer after closing modal
          setTimeout(() => {
            if (this.cart && typeof this.cart.renderContents === 'function') {
              // Fetch fresh cart data and open drawer
              fetch(`${window.Shopify.routes.root}cart.js`)
                .then((response) => response.json())
                .then((cart) => {
                  // Fetch sections for cart drawer
                  const sections = this.cart.getSectionsToRender().map((section) => section.id);
                  const params = new URLSearchParams();
                  params.append('sections', sections.join(','));
                  
                  fetch(`${window.location.pathname}?${params}`)
                    .then((response) => response.json())
                    .then((data) => {
                      const cartResponse = {
                        sections: data,
                        ...cart
                      };
                      this.cart.renderContents(cartResponse);
                    });
                });
            }
          }, 150);

        } catch (error) {
          console.error('Error closing addon modal:', error);
        }
      }

      proceedWithAddToCart(evt) {
        if (!this.submitButton) return;

        // Store original button text
        const originalButtonText = this.submitButtonText ? this.submitButtonText.textContent : '';

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) {
          spinner.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = this.pendingFormData || new FormData(this.form);
        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        
        config.body = formData;
        
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              if (this.submitButtonText) {
                this.submitButtonText.classList.add('hidden');
              }
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;

            // If this is from addon modal, just update cart count and show feedback
            if (this.isFromAddonModal) {
              this.updateCartCount(response);
              
              // Show success feedback on the add to cart button
              if (this.submitButtonText) {
                this.submitButtonText.textContent = window.variantStrings.addedToCart || 'Added to cart';
                this.submitButton.classList.add('added-to-cart');
              }

              // Update the "No Thanks" button to "Close & View Cart"
              const addonModal = this.closest('product-info') 
                ? document.getElementById(`AddOnModal-${this.closest('product-info').dataset.section}`)
                : this.closest('.addon-modal');
                
              if (addonModal) {
                const closeButton = addonModal.querySelector('[id^="ModalClose-"]');
                if (closeButton) {
                  const closeText = closeButton.querySelector('.addon-modal__close-text');
                  if (closeText) {
                    // Change text to "Close & View Cart"
                    closeText.textContent = closeButton.dataset.closeText || 'Close & View Cart';
                    closeButton.classList.add('addon-modal__close-button--updated');
                  }
                }
              }

              // Reset add to cart button after 2 seconds
              setTimeout(() => {
                if (this.submitButtonText) {
                  this.submitButtonText.textContent = originalButtonText;
                  this.submitButton.classList.remove('added-to-cart');
                }
              }, 4000);

            } else {
              // Normal flow - not from addon modal
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      CartPerformance.measure("add:paint-updated-sections", () => {
                        this.cart.renderContents(response);
                      });
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  this.cart.renderContents(response);
                });
              }
            }

            // Clear pending data only if not from addon modal
            if (!this.isFromAddonModal) {
              this.pendingFormData = null;
              this.pendingEvent = null;
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            
            const spinner = this.querySelector('.loading__spinner');
            if (spinner) {
              spinner.classList.add('hidden');
            }

            if (evt && !this.isFromAddonModal) {
              CartPerformance.measureFromEvent("add:user-action", evt);
            }

            // Reset flag
            this.isFromAddonModal = false;
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;
        
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}